import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api/baseQuery";

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Reports"],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getReports: builder.query({
      query: (params = {}) => {
        const { page = 0, pageSize = 8, keyword = "", sortBy = "", sortOrder = "" } = params;
        let url = `/report/list?page=${page}&pageSize=${pageSize}`;
        if (keyword && keyword.trim()) url += `&keyword=${encodeURIComponent(keyword.trim())}`;
        if (sortBy) url += `&sortBy=${encodeURIComponent(sortBy)}`;
        if (sortOrder) url += `&sortOrder=${encodeURIComponent(sortOrder)}`;
        return { url, method: "GET" };
      },
      providesTags: ["Reports"],
      transformResponse: (response) => {
        if (response?.isSuccess && response?.value) {
          return {
            items: response.value.items || response.value.reports || [],
            totalCount: response.value.totalCount || 0,
          };
        }
        // Graceful fallback
        return { items: [], totalCount: 0 };
      },
      transformErrorResponse: (response) => ({
        status: response?.status,
        message: response?.data?.errors?.[0] || response?.data?.message || "Failed to load reports",
      }),
    }),
    createReport: builder.mutation({
      query: (payload) => ({
        url: "/report/create",
        method: "POST",
        body: payload || {},
      }),
      invalidatesTags: ["Reports"],
      transformResponse: (response) => {
        if (response?.isSuccess) {
          return { message: response?.successMessage || "Report created" };
        }
        throw new Error(response?.errors?.[0] || "Failed to create report");
      },
      transformErrorResponse: (response) => ({
        status: response?.status,
        message: response?.data?.errors?.[0] || response?.data?.message || "Failed to create report",
      }),
    }),
  }),
});

export const { useGetReportsQuery, useCreateReportMutation } = reportsApi;

export const { reducer: reportsReducer, middleware: reportsMiddleware, reducerPath: reportsReducerPath } = reportsApi;


